
Checkout.Payment.GiftCard = function(checkout, payment) {
	var giftcard = this;

	this.label = 'Gift Cards';
	this.balance = 0;

	this.$loadingOverlay = $('#giftcard-loading-overlay');
	this.$loadingMsg = this.$loadingOverlay.find('.msg-text');
	this.$error = $('#giftcard-error');
	this.$errorMsg = this.$error.find('.msg-text');
	this.$wrap = $('#payment-method-giftcard');
	this.$content = $('#payment-method-giftcard');
	this.$balance = giftcard.$content.find('.payment-method-amt');
	this.$remainingBalance = giftcard.$content.find('.payment-method-amt-remaining');
	this.$checkbox = $('#payment-method-giftcard-use');
	this.$useBalanceWrap = $('#payment-method-giftcard-use-wrap');
	this.$displayBalance = giftcard.$useBalanceWrap.find('.payment-method-amt');
	this.$cardInput = $('#giftcard-input');
	this.$add = $('#giftcard-add');

	this.request = false;

	this.init = function() {
		giftcard.listen();
	};

	this.listen = function() {

		giftcard.$add.click(giftcard.getCard);

		giftcard.$checkbox.change(function() {
			giftcard.changeUseBalance(true);
		});
	};

	this.buildContent = function() {
		var giftcardBalance = (parseFloat(checkout.session.get('credits.giftCardBalance')) || 0),
			useGiftCards = checkout.session.get('useGiftCards') || 0;

		giftcard.balance = giftcardBalance;

		giftcard.balanceChanged();

		if (giftcard.balance <= 0)
			useGiftCards = 0;

		giftcard.$checkbox.prop('checked', ((useGiftCards) ? true : false));
		giftcard.changeUseBalance(false);

	};

	this.balanceChanged = function() {
		if (checkout.config.isEndeca) {
			giftcard.$displayBalance.html( '$'+giftcard.balance.toMoney() );
		} else {
			giftcard.$balance.html('$'+giftcard.balance.toMoney());
		}

		if (giftcard.balance > 0)
			giftcard.$useBalanceWrap.show();
		else
			giftcard.$useBalanceWrap.hide();

	};

	this.getCard = function() {
		var cardID = giftcard.$cardInput.val().trim().toUpperCase();

		if (giftcard.request)
			giftcard.request.abort();

		if (!cardID)
			return;

		giftcard.error(false);
		giftcard.$cardInput.blur();
		giftcard.loading('Loading Gift Card');

		giftcard.request = checkout.remote.call({
			'data': {
				'step': 'payment',
				'action': 'addGiftCard',
				'cardID': cardID
			}
		})
			.done(function(response) {

				giftcard.$cardInput.val('');

				giftcard.balance = response.data.balance;
				giftcard.balanceChanged();

				giftcard.$checkbox.prop('checked', true);
				giftcard.changeUseBalance(true);
			})
			.fail(function(request) {

				if (request.responseText)
					giftcard.error(request.responseText);
				else
					giftcard.error('Gift Card does not exist or has no remaining balance.');

				giftcard.$cardInput.focus();
			}).
			always(function() {
				giftcard.loading(false);
			});
	};

	this.changeUseBalance = function(userEvent) {
		var useGiftCards = (giftcard.$checkbox.prop('checked') ? 1 : 0);

		if (useGiftCards)
			giftcard.applyBalance(userEvent);
		else
			giftcard.removeBalance(userEvent);

		if (checkout.session.get('useGiftCards') != useGiftCards) {

			checkout.session.set({
				'useGiftCards': useGiftCards
			});

			payment.saved = false;
		}
	};

	this.removeBalance = function(userEvent) {

		giftcard.$balance.css('text-decoration', '');
		giftcard.$remainingBalance.hide();

		if (!payment.methodRequired)
			giftcard.lock();

		payment.changeBalanceMethod(giftcard, 0, userEvent);
	};

	this.lock = function() {
		giftcard.$cardInput.attr('disabled', 'disabled');
		giftcard.$add.attr('disabled', 'disabled');

		if (!giftcard.$checkbox.prop('checked'))
			giftcard.$checkbox.attr('disabled', 'disabled');
	};

	this.unlock = function() {
		giftcard.$cardInput.removeAttr('disabled');
		giftcard.$add.removeAttr('disabled');
		giftcard.$checkbox.removeAttr('disabled');
	};

	this.reApplyBalance = function() {
		if (giftcard.$checkbox.prop('checked'))
			giftcard.applyBalance(false);
	};

	this.applyBalance = function(userEvent) {
		var usedBalanceTotal = 0;

		for (var i=0; i < payment.balanceMethods.length; i++) {
			var method = payment.balanceMethods[i];

			if (method.label == giftcard.label)
				break;
			else
				usedBalanceTotal += (checkout.cart.totals.values.balances[method.label] || 0);
		}

		var applyBalance = (
			(parseFloat(checkout.cart.totals.values.total) || 0)
			- usedBalanceTotal
		);

		if (applyBalance > giftcard.balance)
			applyBalance = giftcard.balance;

		applyBalance = (parseFloat(applyBalance.toMoney()) || 0);

		if (applyBalance <= 0) {
			giftcard.$checkbox.prop('checked', false);
			giftcard.changeUseBalance(false);
			return;
		}

		var remainingBalance = (giftcard.balance - applyBalance);

		if (remainingBalance < 0)
			remainingBalance = 0;

		giftcard.$balance.css('text-decoration', 'line-through');
		giftcard.$remainingBalance
			.html('$'+remainingBalance.toMoney())
			.show();

		payment.changeBalanceMethod(giftcard, applyBalance, userEvent);

	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			giftcard.$loadingMsg.html(loadingMsg);
			giftcard.$loadingOverlay.show();
			checkout.alignMiddle(giftcard.$loadingOverlay.find('.msg'), giftcard.$loadingOverlay);
		} else
			giftcard.$loadingOverlay.hide();
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			var currentMsg = giftcard.$errorMsg.html();

			if (currentMsg)
				giftcard.$errorMsg.html(currentMsg + '<br />' + errorMsg);
			else
				giftcard.$errorMsg.html(errorMsg);

			giftcard.$error.show();

		} else {
			giftcard.$error.hide();
			giftcard.$errorMsg.html('');
		}
	};

	this.init();
};

